import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.resources')
  .factory('$resourceAllocations', ResourceAllocationsFactory);

function ResourceAllocationsFactory($bringozFactory: $bringozFactory,
                                    ResourcesAllocationsApi: BringozApi,
                                    ResourceAllocations_DS: DataStoreConfig) {

  function $resourceAllocations(id: string) {
    return $bringozFactory(id, ResourcesAllocationsApi, ResourceAllocations_DS)
  }
  return $resourceAllocations
}
